import React from 'react';
import './Section4.css';
import emissionImg from './emissionImg.png';
import challengesImg from './challengesImg.png';
import leaderboardImg from './leaderboardImg.png';
import rewardsImg from './rewardsImg.png';

const Section4 = () => {
  return (
    <div className="section4">
      <div className="problem-tag">🔥 PREVIEW</div>
      <h2>
        What Employees <br /> <span className="highlight">See & Do</span>
      </h2>

      <div className="grid-container-app">
        
        {/* Box 1 */}
<div className="appbox appbox1">
  <div className="appbox-content appbox1-content">
    <img src={emissionImg} alt="Emission" className="img-left appbox1-img" />
    <div className="text-content appbox1-text">
      <h3>Emission Overview</h3>
      <p><b>🔍 Track Personal & Team Impact</b></p>
      <li>Their daily CO₂ emissions</li>
      <li>Company-wide average for comparison</li>
      <li>Real-life impact equivalent</li>
    </div>
  </div>
</div>

{/* Box 2 */}
<div className="appbox appbox2">
  <div className="text-content appbox2-text">
  <h3>Eco Challenges</h3>
      <p><b>✅ Daily To-Dos That Drive Change</b></p>
      <li>Employees get bite-sized tasks</li>
      <li>Earn coins & points for each completed challenge.</li>
      <li>Admins can customize challenges </li>
  </div>
  <img src={challengesImg} alt="Challenges" className="img-bottom appbox2-img" />
</div>

{/* Box 3 */}
<div className="appbox appbox3">
  <div className="text-content appbox3-text">
  <h3>Leaderboard</h3>
      <p><b>👥Compete Within Teams & Across Branches</b></p>
      <li>See your ranking vs. others by: <br/>
          → Individual, Team & Branch</li>
      
  </div>
  <img src={leaderboardImg} alt="Leaderboard" className="img-bottom appbox3-img" />
</div>

{/* Box 4 */}
<div className="appbox appbox4">
  <div className="appbox-content reverse appbox4-content">
  <img src={rewardsImg} alt="Rewards" className="img-right appbox4-img" />
    <div className="text-content appbox4-text">
    <h3>Rewards</h3>
      <p><b>🪙Earn Eco-Coins & Get Real Perks</b></p>
      <li>Redeem for discounts on eco-friendly brands/products</li>
      <li>Collect coins through consistent action</li>
      <li>Adds a tangible benefit to every green choice made</li>
    </div>
   
  </div>
</div>

     
      </div>
    </div>
  );
};

export default Section4;